import { Space, Typography } from 'antd';
import { WarningFilled, WarningOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';
import { ValidationWithSubErrors } from 'types/common';
import DotSeparator from 'components/new-ui/base/dot-separator/DotSeparator';
import styled from 'styled-components';
import { groupErrorsByColumn } from './utils';

const SecondaryText = styled.div`
    color: var(--gray-9);
`;

type Props = {
    open: boolean;
    validationResponse: ValidationWithSubErrors;
    onClose: () => void;
    onConfirm: () => void;
};

const FileErrorsModal = ({ open, validationResponse, onClose, onConfirm }: Props) => {
    const grouped = groupErrorsByColumn(validationResponse.subErrors);

    return (
        <ConfirmationModal
            maskClosable={false}
            confirmButtonText="Try Again"
            title="File Errors"
            icon={<WarningOutlined />}
            open={open}
            width={700}
            onCancel={onClose}
            onClose={onClose}
            onConfirm={onConfirm}
            content={
                <div style={{ padding: 16, maxHeight: 480, overflowY: 'auto' }}>
                    <Typography>
                        We detected a few issues with your CSV file. Review the highlighted cells to fix missing or
                        invalid data and try again.
                    </Typography>

                    <Space style={{ width: '100%', marginTop: 10 }} direction="vertical" size={14}>
                        {grouped.map((group) => {
                            const totalRows = group.missingRows.length + group.invalidFormatRows.length;
                            return (
                                <Space style={{ width: '100%' }} direction="vertical" size={2}>
                                    <Space size={8}>
                                        <Space size={4}>
                                            <WarningFilled style={{ color: 'var(--orange-6)' }} />
                                            <strong>{group.column}</strong>
                                        </Space>
                                        <DotSeparator />
                                        <SecondaryText>
                                            {totalRows} row{totalRows !== 1 ? 's' : ''} affected
                                        </SecondaryText>
                                    </Space>

                                    {group.missingRows.length > 0 && (
                                        <SecondaryText>Missing rows: {group.missingRows.join(', ')}</SecondaryText>
                                    )}

                                    {group.invalidFormatRows.length > 0 && (
                                        <SecondaryText>
                                            Invalid format rows: {group.invalidFormatRows.join(', ')}
                                        </SecondaryText>
                                    )}
                                </Space>
                            );
                        })}
                    </Space>
                </div>
            }
        />
    );
};

export default FileErrorsModal;
